<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>公正轉型</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <p>20 多年前台泥在和平水泥工業區打造出全世界唯一港電廠循環經濟園區，現在台泥積極希望將此地轉型成為東部第一個低碳綠能環保園區，朝向資源循環、低碳建材、綠色能源等新發展項目。</p>
        <p>其中，和平電力在朝向淨零轉型過程中也思考可能對既有的經濟、員工及周邊社區產生衝擊，因此如何將包容性與正當性納入公司轉型策略規劃，積極創造、提供氣候減緩調適與轉型需求的工作機會，並透過培力計畫支持受衝擊之利害關係人共同轉型。</p>
        <div class="imgContainer1-1"></div>
        <div class="sectTit">2022 和平來電互動體驗運動會</div>
        <p>住在花蓮和平的居民多數知道自己的部落位於水泥工業區，卻不知道這裡其實也是台灣電力的重要據點，這裏有供應全台灣近 4% 電力的和平電廠，隨著國家能源轉型的政策方向，火力電廠未來也將面對除役，當地部落許多福利項目均來自電廠回饋金，甚至每兩個月各家戶電表均有三～四千元的電費補助，如何攜手周邊社區提升減碳認知、共同瞭望一個更美好的未來是和平電力極為重視的課題。</p>
        <p>和平電力依循台泥企業團的發展策略，攜手同集團的台泥綠能團隊，規劃於和平開展全球第一個MW 級的海洋溫差發電基地，因此提前展開社區溝通，於 2022 年 12 月和平村一年一度的村校運動會同場舉辦了「和平來電」活動，邀請和平村親子共同以闖關體驗，認識和平 20 年來的重要供電角色以及未來可能轉向綠能發展。</p>
        <p>闖關活動中我們設置了電力故鄉、和平低碳環保綠能園區、光風地海再生能源、EV 生活與電池儲能、海洋溫差發電、台泥電機人才培訓專班五個體驗關卡。這裡面有過去 20 年和平青年投入電廠的光榮歷史，也有自 2020 年台泥在和平陸續設置的大型太陽能戶外發電暨藝術裝置以及結合儲能的充電站。</p>
      </div>
    </section>
    <section class="sect2">
      <div class="ctx">
        <swiper
          :modules = "modules"
          :slides-per-view="1"
          :space-between="1"
          :autoplay="{delay:3000, disableOnInteraction:false}"
          :speed="1000"
          :loop="true"
          :pagination="{clickable:true}"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          class="swiper"
        >
          <swiper-slide class="cover cover1"></swiper-slide>
          <swiper-slide class="cover cover2"></swiper-slide>
          <swiper-slide class="cover cover3"></swiper-slide>
          <swiper-slide class="cover cover4"></swiper-slide>
        </swiper>
      </div>
    </section>
    <section class="sect3">
      <div class="ctx">
        <p>和平村是花蓮秀林鄉第一個設有象徵電動化時代充電設施的部落，小朋友們對駛入村莊的各式電動車如數家珍，闖關活動中透過觸摸、聆聽來了解電動車不再使用傳統汽油也看不到引擎，而是靠著 8,000 顆鋰電池產生動力，透過試乘讓部落的大人小孩體驗未來生活轉型可能的樣貌。</p>
        <p>和平電力同仁也設計了科學教具，讓親子透過操作注入冷熱水形成溫差進而產生電力、轉動風扇，並進一步想像，未來和平地區是否可能透過低溫海水與和平電廠溫排水交互運用產生電力。</p>
        <p>活動中也邀請台泥和平廠和花蓮四維高中合作的「電機技術人才產學合作專班」在學生，來分享自己就讀專班學習到的技術專業與考取證照計畫。台泥電機技術人才專班於 2022 年 9 月開辦，優先錄取和平地區國中畢業生，並不定期安排台泥儲能、綠能電池團隊主管到校分享，希望協助和平村在面對在地企業低碳轉型時，部落年輕世代也具備綠色產業所需技能與投入相關工作的機會。</p>
        <br>
        <div class="left">
          <div class="sectTit">和平減碳生活親子存摺</div>
          <p>台泥企業團 2023 年 3 月起推動「和平減碳生活親子存摺」，第一階段先與部落的教育中心「和平國小」合作，以親子為組合，學校、社區、住家三個場域實踐減碳，透過老師引導學童在校園午餐完食來減少廚餘並落實分類回收，下課後鼓勵親子定期到台泥 DAKA 園區內的「GEMMA 智慧回收機」回收寶特瓶、手搖杯、鋁罐及電池，返家後由家長引導改變生活習慣、節能減碳。</p>
          <p>參與的親子組可依每項減碳行動包括台電電費單上的減少用電度數所達成的減碳量獲得「碳幣」，紀錄於存摺中，累計之碳幣在學期末由台泥以獲得環境部碳標籤或減碳標籤之商品與親子「交易」他們的減碳努力。碳幣，形成一種鼓勵機制，獎勵品的選定亦希望帶動親子認識並支持願意揭露碳排以及投入減碳的企業品牌。</p>
        </div>
        <div class="right">
          <div class="imgContainer3-1"></div>
          <div class="imgContainer3-2"></div>
        </div>
        <div class="clear"></div>
      </div>
    </section>
    <section class="sect4">
      <div class="ctx">
        <div class="sectTit">落實減碳的方法與成效</div>
        <div class="reduceCarbonMethod">
          <div class="item" v-for="(row, idx) in reduceCarbonMethod" :key=idx>
            <img class="icon" :src="setReduceCarbonMethodIcon(row.icon)" />
            <div class="tit">
              <div>{{row.tit}}</div>
              <div class="arrow">
                <div class="stick"></div>
                <div class="tri"></div>
              </div>
            </div>
            <div class="spec" v-html="row.spec"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="sect5">
      <div class="ctx">
        <div class="sectTit">減碳小達人</div>
        <div class="reduceMaster">
          <div class="item" v-for="(row, idx) in reduceMaster" :key=idx>
            <img class="pic" :src="setReduceCarbonMasterPic(row.pic)" />
            <div class="info">
              <div class="left">
                <div class="sign">#</div>
              </div>
              <div class="right">
                <div class="tit">{{row.tit}}</div>
                <div class="desp">{{row.desp}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="sect6">
      <div class="ctx">
        <div class="left">
          <p>2024 年 3 月，和平減碳生活親子存摺計畫進入第二階段，成員包括台泥在和平電廠的在地同仁親子組，並擴大至社區克尼布及吾谷子媽媽教室成員，希望進一步將節電減碳的認知擴散至村莊內。</p>
          <p>和平減碳生活親子存摺計畫也得到了 NGO 與社會企業的專業支持，荒野保護協會花蓮分會楊和玉主任秘書，特別到和平村傳授節能減碳的正確觀念及日常生活中聰明用電與減碳妙招，包括：</p>
        </div>
        <div class="right">
          <div class="reduceCarbonJoin">
            <div class="item" v-for="(row, idx) in reduceCarbonJoin" :key="idx">
              <div class="imgContainer6" :style="setReduceCarbonJoinPic(row.pic)"></div>
              <div class="desp">{{row.desp}}</div>
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="saveElec">
          <div class="item" v-for="(row, idx) in saveElec" :key="idx">
            <div class="icon"><img :src="setSaveElecIcon(row.icon)" /></div>
            <div class="desp" v-html="row.desp"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="sect7">
      <div class="ctx">
        <div class="left">
          <div>此外，致力資源循環的社會企業 FNG 所打造的「好歸塑巡迴車」也特別開到花蓮和平駐點，大家把寶特瓶投入巡迴車上的投瓶口，車上內建的機器會立即輾壓成碎片，FNG 團隊也向部落朋友們展示這些寶特瓶碎片後續可以再製成環保袋、野餐墊與拖鞋。好歸塑巡迴車還會即時顯示在民眾投瓶行動後，減少的碳排放量和節省的水資源量，讓每個人都能快速掌握減碳小知識，活動累積減碳量 19,320g。</div>
          <p>另外，和平電廠各式活動舉辦都以 QRcode 掃描報到減少紙張用量、講座場地冷氣設定 26 度搭配電風扇、活動道具都是第N 次再利用、甚至部落媽媽教室成員還共乘和平廠關懷巴士減少運輸碳足跡、自備環保杯裝飲品等，從小事中攜手生活轉型。</p>
        </div>
        <div class="right">
          <div class="imgContainer7-1"></div>
        </div>
        <div class="clear"></div>
        <div class="gallery">
          <div class="imgContainer7-2"></div>
          <div class="imgContainer7-3"></div>
          <div class="imgContainer7-4"></div>
          <div class="imgContainer7-5"></div>
        </div>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ImgContainerAutoResize } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export default defineComponent({
  name: 'JustTransition',
  components: {
    Header,
    Footer,
    Swiper,
    SwiperSlide
  },
  setup() {
    const onSwiper = (swiper: any) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay]
    };
  },
  data() {
    return {
      reduceCarbonMethod: [
        {
          tit: "認知",
          spec: "節電、回收、海洋教育<br>攜手NGO開設減碳課程",
          icon: "icon4_01.png"
        },
        {
          tit: "行動",
          spec: "家戶節電</br>完食行動</br>資源回收",
          icon: "icon4_02.png"
        },
        {
          tit: "碳幣",
          spec: "依每項行動減碳量<br>獲得碳幣",
          icon: "icon4_03.png"
        },
        {
          tit: "存摺",
          spec: "碳幣累計登錄存摺",
          icon: "icon4_04.png"
        },
        {
          tit: "兌換碳標籤商品",
          spec: "台泥與在地居民<br>進行碳權交易",
          icon: "icon4_05.png"
        }
      ],
      reduceMaster: [
        {
          tit: "減碳第一名",
          desp: "陳首維同學會跟媽媽討論如何減少開關冰箱門、假日也和大人一起到 DAKA 園區智慧回收機投寶特瓶，上學期累積超過 166 公斤的減碳量。",
          pic: "pic5_01.png"
        },
        {
          tit: "節電第一名",
          desp: "李安楨同學全家 10 口三代同住，因此晚間時段會盡量聚集在一樓用餐、看電視或到門口乘涼，只有睡覺才回房間開冷氣，一口氣省下 287 度電。",
          pic: "pic5_02.png"
        },
        {
          tit: "學期總減碳量第一名",
          desp: "和平國小三年甲班上學期減碳共 212 公斤，為全校總減碳量第一名，班導林立雅老師分享因為這個計畫，學生開始注意村子裡、街道上的垃圾，會主動幫忙撿拾也把可回收的資源帶回家。",
          pic: "pic5_03.png"
        }
      ],
      reduceCarbonJoin: [
        {
          desp: "和平電力在地員工何胤丞，積極參與減碳生活親子存摺計畫",
          pic: "pic6_01.png"
        },
        {
          desp: "透過媽媽教室的課程，擴大宣導節能環保減碳的正確觀念",
          pic: "pic6_02.png"
        }
      ],
      saveElec: [
        {
          desp: "衣服先泡再洗<br>乾淨又節電",
          icon: "icon6_01.png"
        },
        {
          desp: "開冷氣應先<br>開窗散熱後<br>再緊閉窗戶",
          icon: "icon6_02.png"
        },
        {
          desp: "選用<br>節電標章電器<br>省電費",
          icon: "icon6_03.png"
        },
        {
          desp: "節電省電費<br>還可<br>領台電獎勵金",
          icon: "icon6_04.png"
        }
      ],
    }
  },
  methods:{
    setReduceCarbonMethodIcon: function(file: string) {
      return require(`@/assets/justTransition/${file}`);
    },
    setReduceCarbonMasterPic: function(file: string) {
      return require(`@/assets/justTransition/${file}`);
    },
    setReduceCarbonJoinPic: function(file: string) {
      return {
        background: `url(${require(`@/assets/justTransition/${file}`)})`,
        backgroundSize: "cover"
      }
    },
    setSaveElecIcon: function(file: string) {
      return require(`@/assets/justTransition/${file}`);
    },
  },
  mounted() {
    // let swiperPageination = (document.querySelector(".swiper-pagination") as HTMLElement).cloneNode(true);
    // (document.querySelector(".swiper") as HTMLElement).after(swiperPageination);    

    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-1") as HTMLElement, 0.7);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover1") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover2") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover3") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover4") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-1") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-2") as HTMLElement, 0.57);
    document.querySelectorAll(".imgContainer6").forEach( (elem) => {
      new ImgContainerAutoResize(elem as HTMLElement, 0.65);
    });
    new ImgContainerAutoResize(document.querySelector(".imgContainer7-1") as HTMLElement, 0.8);
    new ImgContainerAutoResize(document.querySelector(".imgContainer7-2") as HTMLElement, 0.37);
    new ImgContainerAutoResize(document.querySelector(".imgContainer7-3") as HTMLElement, 0.85);
    new ImgContainerAutoResize(document.querySelector(".imgContainer7-4") as HTMLElement, 0.85);
    new ImgContainerAutoResize(document.querySelector(".imgContainer7-5") as HTMLElement, 0.85);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0, rgba(0, 0, 0, 0) 20%), url("@/assets/justTransition/kv.webp");
  background-position: center, center 45%;
  background-size: cover, cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 .sectTit {
  margin: 0 0 10px;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect1 p {
  line-height: 2em;
}

.sect1 .imgContainer1-1 {
  margin: 40px 0;
  border-radius: 30px;
  background: url(@/assets/justTransition/pic1_01.jpg) center;
  background-size: cover;
}

.sect2 {
  background: #63BFAA;
}

.sect2 .swiper {
  border-radius: 30px;
}

.sect2 .swiper .swiper-wrapper {
  /* overflow: hidden; */
}

.sect2 .swiper .cover1 {
    background: url(../../assets/justTransition/carousel2_01.webp) center;
    background-size: cover;
}

.sect2 .swiper .cover2 {
    background: url(../../assets/justTransition/carousel2_02.webp) center;
    background-size: cover;
}

.sect2 .swiper .cover3 {
    background: url(../../assets/justTransition/carousel2_03.webp) center 85%;
    background-size: cover;
}

.sect2 .swiper .cover4 {
    background: url(../../assets/justTransition/carousel2_04.webp) center;
    background-size: cover;
}

.sect2 .swiper .swiper-pagination {
  /* bottom: -40px !important; */
}

.sect2 .swiper .swiper-pagination .swiper-pagination-bullet {
  width: 15px;
  height: 15px;
  border: solid 1px #fff;
  background: #404040;
  opacity: 0.8;
}

.sect2 .swiper .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #fff;
}

/* .swiper-button-next:after {
  padding: 10px;
  font-size: 60px;
  background: #00000088;
} */

.sect3 .ctx {
  padding: 60px 0 100px;
}

.sect3 p {
  line-height: 2em;
}

.sect3 .left {
  width: 50%;
  margin: 40px 0;
  float: left;
}

.sect3 .left .sectTit {
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect3 .right {
  width: 45%;
  margin: 40px 0;
  float: right;
}

.sect3 .right .imgContainer3-1 {                         
  margin: 0 0 10px;
  border-radius: 30px;
  background: url(@/assets/justTransition/pic3_01.jpg) center;
  background-size: cover;
}

.sect3 .right .imgContainer3-2 {
  margin: 10px 0 0;
  background: url(@/assets/justTransition/pic3_02.png) center;
  background-size: cover;
}

.sect4 {
  background: #fff;
}

.sect4 .sectTit  {
  width: 450px;
  margin: auto;
  padding: 10px 20px;
  box-sizing: border-box;
  position: absolute;
  top: -35px;
  left: 0;
  right: 0;
  border-radius: 50px;
  letter-spacing: 2px;
  text-align: center;
  font-size: 36px;
  color: #fff;
  background: #E99776;
}

.sect4 .diagram {
  width: 100%;
  margin: 0 0 20px;
}

.sect4 .reduceCarbonMethod {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect4 .reduceCarbonMethod .item {
  flex: 0 0 19%;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 20px;
  text-align: center;
  background: #fff;
}

.sect4 .reduceCarbonMethod .item .icon {
  width: 200px;
  vertical-align: bottom;
}

.sect4 .reduceCarbonMethod .item .tit {
  width: 160px;
  margin: -15px auto 0;
  padding: 5px 0;
  border-radius: 30px;
  position: relative;
  font-size: 24px;
  color: #000;
  background: #f2c400;
}

.sect4 .reduceCarbonMethod .item:nth-child(5) .tit {
  width: 100%;
  background: #E99776;
}

.sect4 .reduceCarbonMethod .item .tit .arrow {
  width: 50%;
  height: 40px;
  margin: auto;
  display: flex;
  align-items: center;
  position: absolute;
  left: 85%;
  top: 0;
  bottom: 0;
  /* background: #40404022; */
}

.sect4 .reduceCarbonMethod .item:nth-child(5) .tit .arrow {
  display: none;
}

.sect4 .reduceCarbonMethod .item .tit .arrow .stick {  
  flex: 1 0 auto;
  height: 15px;
  background: #f2c400;
}

.sect4 .reduceCarbonMethod .item .tit .arrow .tri {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 20px 0 20px 20px;
  border-color: transparent transparent transparent #f2c400;  
}

.sect4 .reduceCarbonMethod .item .spec {
  padding: 10px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.sect5 {
  background: #fff;
}

.sect5 .sectTit {
  width: 270px;
  margin: auto;
  padding: 10px 20px;
  box-sizing: border-box;
  position: absolute;
  top: -35px;
  left: 0;
  right: 0;
  border-radius: 50px;
  letter-spacing: 2px;
  text-align: center;
  font-size: 36px;
  color: #fff;
  background: #E99776;
}

.sect5 .reduceMaster {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect5 .reduceMaster .item {
  flex: 0 0 30%;
}

.sect5 .reduceMaster .item .pic {
  height: 200px;
  margin: 0 auto 20px;
  display: block;
}

.sect5 .reduceMaster .item .info {
  display: flex;
  justify-content: space-between;
}

.sect5 .reduceMaster .item .info .left {
  flex: 0 0 40px;
}

.sect5 .reduceMaster .item .info .left .sign {
  line-height: 1em;
  font-family: arial;
  font-weight: bold;
  font-size: 52px;
  color: #E99776;
  transform: translateY(-10px);
}

.sect5 .reduceMaster .item .info .right {
  flex: 0 1 auto;
  line-height: 1.6em;
}

.sect5 .reduceMaster .item .info .right .tit {
  color: #0C5F99;
}

.sect6 {
  background: #C9E5E0;
}

.sect6 p {
  line-height: 2em;
}

.sect6 .left {
  width: 47%;
  float: left;
}

.sect6 .right {
  width: 47%;
  float: right;
}

.sect6 .right .reduceCarbonJoin {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect6 .right .reduceCarbonJoin .item {
  flex: 0 0 49%;
}

.sect6 .right .reduceCarbonJoin .item .desp {
  padding: 10px 20px;
  box-sizing: border-box;
  font-size: 16px;
  background: #fff;
}

.sect6 .saveElec {
  margin: 20px 0 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect6 .saveElec .item {
  flex: 0 0 24%;
  padding: 20px 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 50px;
  background: #898989;
}

.sect6 .saveElec .item:nth-child(2) {
  background: #64C0AB;
}

.sect6 .saveElec .item:nth-child(3) {
  background: #0C5F9A;
}

.sect6 .saveElec .item:nth-child(4) {
  background: #EA9876;
}

.sect6 .saveElec .item .icon {
  flex: 0 0 40%;
  padding: 0 15px;
  box-sizing: border-box;
}

.sect6 .saveElec .item .icon img {
  width: 100%;
}

.sect6 .saveElec .item .desp {
  flex: 0 0 60%;
  height: 100%;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-left: solid 1px #fff;
  color: #fff;
}

.sect7 {
  background: #fff;
}

.sect7 .left {
  width: 47%;
  float: left;
  line-height: 2em;
}

.sect7 .right {
  width: 47%;
  float: right;
}

.sect7 .right .imgContainer7-1 {
  border-radius: 30px;
  background: url(@/assets/justTransition/pic7_01.jpg) center;
  background-size: cover;
}

.sect7 .gallery {
  margin: 40px 0 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-radius: 30px;
  overflow: hidden;
}

.sect7 .gallery .imgContainer7-2 {
  flex: 0 0 100%;
  margin: 0 0 5px;
  background: url(@/assets/justTransition/pic7_02.jpg) center;
  background-size: cover;
}

.sect7 .gallery .imgContainer7-3 {
  flex: 0 0 33%;
  margin: 0 0 5px;
  background: url(@/assets/justTransition/pic7_03.jpg) center;
  background-size: cover;
}

.sect7 .gallery .imgContainer7-4 {
  flex: 0 0 33%;
  margin: 0 0 5px;
  background: url(@/assets/justTransition/pic7_04.jpg) center;
  background-size: cover;
}

.sect7 .gallery .imgContainer7-5 {
  flex: 0 0 33%;
  margin: 0 0 5px;
  background: url(@/assets/justTransition/pic7_05.jpg) center;
  background-size: cover;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }

  .sect3 .ctx {
    padding: 40px;
  }

  .sect3 .left {
    width: 100%;
    margin: 10px 0;
  }

  .sect3 .right {
    width: 100%;
    margin: 10px 0 60px;
  }

  .sect3 .right .imgContainer3-1 {                         
    margin: 0 0 10px;
    border-radius: 30px;
  }

  .sect3 .right .imgContainer3-2 {
    width: 80%;
    margin: 10px 10% 0;
  }

  .sect4 .reduceCarbonMethod {
    width: 650px;
    margin: 20px auto 40px;
    padding: 0 0 20px;
    justify-content: space-around;
    border-bottom: dotted 1px #c0c0c0;
  }

  .sect5 .reduceMaster .item:nth-child(1),
  .sect5 .reduceMaster .item:nth-child(2) {
    flex: 0 0 45%;
    margin: 20px 0;
  }

  .sect5 .reduceMaster .item:nth-child(3) {
    flex: 0 0 100%;
    margin: 20px 0;
  }

    .sect6 .left {
    width: 100%;
  }

  .sect6 .right {
    width: 100%;
  }

  .sect6 .right .reduceCarbonJoin .item {
    flex: 0 0 49%;
    margin: 5px 0;
  }

  .sect6 .right .reduceCarbonJoin .item .desp {
    padding: 10px;
  }

  .sect6 .saveElec .item {
    flex: 0 0 49%;
    margin: 5px 0;
  }

  .sect7 .left {
    width: 100%;
  }

  .sect7 .right {
    width: 100%;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect3 .ctx {
    padding: 40px 20px;
  }

  .sect3 .left {
    width: 100%;
    margin: 0;
  }

  .sect3 .left .sectTit {
    padding: 5px 0;
    box-sizing: border-box;
    display: inline-block;
    border-top: solid 1px #0C5F99;
    border-bottom: solid 1px #0C5F99;
    letter-spacing: 2px;
    font-size: 24px;
    color: #0C5F99;
  }

  .sect3 .right {
    width: 100%;
    margin: 0 0 40px;
  }

  .sect4 .sectTit  {
    width: 320px;
    font-size: 24px;
  }

  .sect4 .reduceCarbonMethod .item {
    flex: 0 0 100%;
  }

  .sect4 .reduceCarbonMethod .item .tit .arrow {
    display: none;
  }

  .sect5 .sectTit {
    width: 270px;
    font-size: 24px;
  }

  .sect5 .reduceMaster .item {
    flex: 0 0 100%;
  }

  .sect6 .left {
    width: 100%;
  }

  .sect6 .right {
    width: 100%;
  }

  .sect6 .right .reduceCarbonJoin .item {
    flex: 0 0 100%;
    margin: 5px 0;
  }

  .sect6 .saveElec .item {
    flex: 0 0 100%;
    margin: 5px 0;
  }

  .sect7 .left {
    width: 100%;
  }

  .sect7 .right {
    width: 100%;
  }

  .sect7 .gallery .imgContainer7-2 {
    flex: 0 0 100%;
  }

  .sect7 .gallery .imgContainer7-3 {
    flex: 0 0 100%;
  }

  .sect7 .gallery .imgContainer7-4 {
    flex: 0 0 100%;
  }

  .sect7 .gallery .imgContainer7-5 {
    flex: 0 0 100%;
  }
}
</style>
